import { render, staticRenderFns } from "./NidStatus.vue?vue&type=template&id=0f835dfc&scoped=true"
import script from "./NidStatus.vue?vue&type=script&lang=js"
export * from "./NidStatus.vue?vue&type=script&lang=js"
import style0 from "./NidStatus.vue?vue&type=style&index=0&id=0f835dfc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f835dfc",
  null
  
)

export default component.exports